<template>
	<Service class="patrash">
		<h2>Service</h2>

		<p class="year">2017</p>

		<h3>KENPARIS（ケンパリス）</h3>

		<p class="event">MashupAwards2017 大阪ハッカソン「遊びのReハック」最優秀賞</p>
		<p class="role">idea / logo / UI Design / Player</p>

		<section class="logo content-box">
			<h4>Logo</h4>
			<img src="images/service/kenparis/logo.png" />
		</section>

		<section class="story content-box">
			<h4>Story</h4>
			<p>
				大阪で行われたハッカソンで、昔の遊びと今の遊びをくみあわせたアイデアをだし、 ケンケンパとテトリスを組み合わせた「KENPARIS」が生まれた。
				画面をみないで、観客に教えてもらうリバースモードやケンケンパコンボ、永久的にケンケンパし続ける鬼のようなゲームとなった。
				イベントでのプレゼンを数回、アイデアについてのお話をするため高知に呼ばれた。
			</p>
		</section>

		<section class="blog content-box">
			<h4>Blog</h4>

			<p>
				大阪で、遊んで！飛んで！ハックして！ #MA_2017
				<br />
				<a
					href="http://kotobuking.net/kotoblog/2017/10/ma2017_osakahack/"
					target="_blank"
					class="url"
				>http://kotobuking.net/kotoblog/2017/10/ma2017_osakahack/</a>
			</p>
			<p>
				ケンケンパしてたら、高知に呼ばれました。
				<br />
				<a
					href="http://kotobuking.net/kotoblog/2018/02/kochi_idea/"
					target="_blank"
					class="url"
				>http://kotobuking.net/kotoblog/2018/02/kochi_idea/</a>
			</p>
			<p>
				KENPARISプレイ動画<br />
				<iframe
					class="youtube"
					width="560"
					height="315"
					src="https://www.youtube.com/embed/1ahPVLYev4I"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</p>
			<p>
				KENPARISアイデアについての登壇スライド
				<br />
				<a
					href="https://speakerdeck.com/mihoyamamori/gao-zhi-xian-apurikai-fa-ren-cai-yu-cheng-jiang-zuo-ying-yong-bian"
					target="_blank"
				>
					<img src="images/service/kenparis/slide.png" class="slide" />
				</a>
			</p>
		</section>

		<section class="design">
			<h4>Design</h4>
			<p>懐かしい感じと、POPさで楽しい画面に。子供も大人も楽しめる。</p>
			<p>
				KENPARISプレイ動画
				<br />
				<iframe
					class="youtube"
					width="560"
					height="315"
					src="https://www.youtube.com/embed/a1I83ib17AY"
					frameborder="0"
					allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</p>
			<img src="images/service/kenparis/about.png" />
			<img src="images/service/kenparis/game.png" />
		</section>
	</Service>
</template>

<style lang="scss" scoped>
.patrash {
	.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 320px;
			margin: 0 auto;
		}
	}

	.blog {
		> p {
			text-align: center;
			margin-bottom: 20px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		img.slide {
			width: 600px;
		}
	}

	.design {
		> p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 600px;
			margin: 0 auto 24px;
		}
	}
	@media screen and (max-width: 480px) { 
.logo {
		> img {
			width: 275px;
			margin-bottom: 30px;
		}

		p {
			width: 90%;
			margin: 0 auto;
		}
	}

	.blog {
		> p {
			text-align: center;
			margin-bottom: 20px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		img.slide {
			width: 100%;
		}
	}

	.design {
		> p {
			text-align: center;
			margin-bottom: 20px;
		}

		img {
			width: 100%;
			margin: 0 auto 24px;
		}
	}
	iframe{
		width: 100%;
	}

	}
}
</style>

<script>
import Service from "@/components/Service.vue";

export default {
	components: {
		Service
	}
};
</script>
